"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpProficientBandLegend: {
        highlyProficient: 'Highly Proficient',
        proficient: 'Proficient',
        partial: 'Partially Proficient',
        notYet: 'Not Yet Proficient',
    },
};
